import { get, post } from '../utils/api';

/**
 * 邀请服务
 */
export const inviteService = {
  // 获取用户邀请列表
  getUserInvites: async (walletAddress) => {
    const response = await get(`/invites/user/${walletAddress}`);
    return response.data;
  },

  // 绑定邀请关系
  bindInvite: async (inviteeAddress, inviteCode) => {
    // 后端接口使用@RequestParam，参数作为查询字符串传递
    const response = await post(`/invites/bind?inviteeAddress=${encodeURIComponent(inviteeAddress)}&inviteCode=${encodeURIComponent(inviteCode)}`);
    return response.data;
  },
};

